'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var once = require('once');

var PeerId = require('peer-id');

var waterfall = require('async/waterfall');

var multiaddr = require('multiaddr');

var Connection = require('interface-connection').Connection;

var utilsFactory = require('./utils');

var StreamHandler = require('./stream-handler');

var debug = require('debug');

var log = debug('libp2p:circuit:dialer');
log.err = debug('libp2p:circuit:error:dialer');

var multicodec = require('../multicodec');

var proto = require('../protocol');

var Dialer =
/*#__PURE__*/
function () {
  /**
   * Creates an instance of Dialer.
   * @param {Swarm} swarm - the swarm
   * @param {any} options - config options
   *
   * @memberOf Dialer
   */
  function Dialer(swarm, options) {
    _classCallCheck(this, Dialer);

    this.swarm = swarm;
    this.relayPeers = new Map();
    this.relayConns = new Map();
    this.options = options;
    this.utils = utilsFactory(swarm);
  }
  /**
   * Helper that returns a relay connection
   *
   * @param {*} relay
   * @param {*} callback
   * @returns {Function} - callback
   */


  _createClass(Dialer, [{
    key: "_dialRelayHelper",
    value: function _dialRelayHelper(relay, callback) {
      if (this.relayConns.has(relay.id.toB58String())) {
        return callback(null, this.relayConns.get(relay.id.toB58String()));
      }

      return this._dialRelay(relay, callback);
    }
    /**
     * Dial a peer over a relay
     *
     * @param {multiaddr} ma - the multiaddr of the peer to dial
     * @param {Function} cb - a callback called once dialed
     * @returns {Connection} - the connection
     *
     */

  }, {
    key: "dial",
    value: function dial(ma, cb) {
      cb = cb || function () {};

      var strMa = ma.toString();

      if (!strMa.includes('/p2p-circuit')) {
        log.err('invalid circuit address');
        return cb(new Error('invalid circuit address'));
      }

      var addr = strMa.split('p2p-circuit'); // extract relay address if any

      var relay = addr[0] === '/' ? null : multiaddr(addr[0]);
      var peer = multiaddr(addr[1] || addr[0]);
      var dstConn = new Connection();
      setImmediate(this._dialPeer.bind(this), peer, relay, function (err, conn) {
        if (err) {
          log.err(err);
          return cb(err);
        }

        dstConn.setInnerConn(conn);
        cb(null, dstConn);
      });
      return dstConn;
    }
    /**
     * Does the peer support the HOP protocol
     *
     * @param {PeerInfo} peer
     * @param {Function} callback
     * @returns {void}
     */

  }, {
    key: "canHop",
    value: function canHop(peer, callback) {
      var _this = this;

      callback = once(callback || function () {});

      this._dialRelayHelper(peer, function (err, conn) {
        if (err) {
          return callback(err);
        }

        var sh = new StreamHandler(conn);
        waterfall([function (cb) {
          return sh.write(proto.CircuitRelay.encode({
            type: proto.CircuitRelay.Type.CAN_HOP
          }), cb);
        }, function (cb) {
          return sh.read(cb);
        }], function (err, msg) {
          if (err) {
            return callback(err);
          }

          var response = proto.CircuitRelay.decode(msg);

          if (response.code !== proto.CircuitRelay.Status.SUCCESS) {
            var _err = new Error("HOP not supported, skipping - ".concat(_this.utils.getB58String(peer)));

            log(_err);
            return callback(_err);
          }

          log("HOP supported adding as relay - ".concat(_this.utils.getB58String(peer)));

          _this.relayPeers.set(_this.utils.getB58String(peer), peer);

          sh.close();
          callback();
        });
      });
    }
    /**
     * Dial the destination peer over a relay
     *
     * @param {multiaddr} dstMa
     * @param {Connection|PeerInfo} relay
     * @param {Function} cb
     * @return {Function|void}
     * @private
     */

  }, {
    key: "_dialPeer",
    value: function _dialPeer(dstMa, relay, cb) {
      var _this2 = this;

      if (typeof relay === 'function') {
        cb = relay;
        relay = null;
      }

      if (!cb) {
        cb = function cb() {};
      }

      dstMa = multiaddr(dstMa); // if no relay provided, dial on all available relays until one succeeds

      if (!relay) {
        var relays = Array.from(this.relayPeers.values());

        var next = function next(nextRelay) {
          if (!nextRelay) {
            var err = "no relay peers were found or all relays failed to dial";
            log.err(err);
            return cb(err);
          }

          return _this2._negotiateRelay(nextRelay, dstMa, function (err, conn) {
            if (err) {
              log.err(err);
              return next(relays.shift());
            }

            cb(null, conn);
          });
        };

        next(relays.shift());
      } else {
        return this._negotiateRelay(relay, dstMa, function (err, conn) {
          if (err) {
            log.err("An error has occurred negotiating the relay connection", err);
            return cb(err);
          }

          return cb(null, conn);
        });
      }
    }
    /**
     * Negotiate the relay connection
     *
     * @param {Multiaddr|PeerInfo|Connection} relay - the Connection or PeerInfo of the relay
     * @param {multiaddr} dstMa - the multiaddr of the peer to relay the connection for
     * @param {Function} callback - a callback which gets the negotiated relay connection
     * @returns {void}
     * @private
     *
     * @memberOf Dialer
     */

  }, {
    key: "_negotiateRelay",
    value: function _negotiateRelay(relay, dstMa, callback) {
      var _this3 = this;

      dstMa = multiaddr(dstMa);
      relay = this.utils.peerInfoFromMa(relay);

      var srcMas = this.swarm._peerInfo.multiaddrs.toArray();

      this._dialRelayHelper(relay, function (err, conn) {
        if (err) {
          log.err(err);
          return callback(err);
        }

        var sh = new StreamHandler(conn);
        waterfall([function (cb) {
          log("negotiating relay for peer ".concat(dstMa.getPeerId()));
          var dstPeerId;

          try {
            dstPeerId = PeerId.createFromB58String(dstMa.getPeerId()).id;
          } catch (err) {
            return cb(err);
          }

          sh.write(proto.CircuitRelay.encode({
            type: proto.CircuitRelay.Type.HOP,
            srcPeer: {
              id: _this3.swarm._peerInfo.id.id,
              addrs: srcMas.map(function (addr) {
                return addr.buffer;
              })
            },
            dstPeer: {
              id: dstPeerId,
              addrs: [dstMa.buffer]
            }
          }), cb);
        }, function (cb) {
          return sh.read(cb);
        }], function (err, msg) {
          if (err) {
            return callback(err);
          }

          var message = proto.CircuitRelay.decode(msg);

          if (message.type !== proto.CircuitRelay.Type.STATUS) {
            return callback(new Error("Got invalid message type - " + "expected ".concat(proto.CircuitRelay.Type.STATUS, " got ").concat(message.type)));
          }

          if (message.code !== proto.CircuitRelay.Status.SUCCESS) {
            return callback(new Error("Got ".concat(message.code, " error code trying to dial over relay")));
          }

          callback(null, new Connection(sh.rest()));
        });
      });
    }
    /**
     * Dial a relay peer by its PeerInfo
     *
     * @param {PeerInfo} peer - the PeerInfo of the relay peer
     * @param {Function} cb - a callback with the connection to the relay peer
     * @returns {void}
     * @private
     */

  }, {
    key: "_dialRelay",
    value: function _dialRelay(peer, cb) {
      cb = once(cb || function () {});
      this.swarm.dial(peer, multicodec.relay, once(function (err, conn) {
        if (err) {
          log.err(err);
          return cb(err);
        }

        cb(null, conn);
      }));
    }
  }]);

  return Dialer;
}();

module.exports = Dialer;